import { makeStyles } from '@material-ui/core/styles';
import { i18n } from '../../../../language';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexGrow: '1',
    flexShrink: '1',
    marginLeft: '-0.063rem',
    width: '10.875rem',
  },
  day: {
    width: '100%',
  },
  head: {
    width: '100%',
    height: '3.125rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: theme.palette.font.main,
    fontWeight: 'bold',
  },
  num: {
    marginLeft: '0.875rem',
    width: '1.75rem',
    height: '1.75rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  body: {
    minHeight: '40rem',
    width: '100%',
    height: '100%',
    border: '0.063rem solid #d7e3f1',
    borderBottom: '0',
    padding: '0.563rem 0.563rem 0',
  },
}));

export default function Day({ num, mark, children, index }) {
  const classes = useStyles();
  const weekInit = [
    i18n.t('DUTYASSIGN_RELIEVING_SUN'),
    i18n.t('DUTYASSIGN_RELIEVING_MON'),
    i18n.t('DUTYASSIGN_RELIEVING_TUE'),
    i18n.t('DUTYASSIGN_RELIEVING_WED'),
    i18n.t('DUTYASSIGN_RELIEVING_THU'),
    i18n.t('DUTYASSIGN_RELIEVING_FRI'),
    i18n.t('DUTYASSIGN_RELIEVING_SAT'),
  ];

  function styleContrl() {
    if (mark) {
      return {
        backgroundColor: '#538fff',
        color: '#fff',
        borderRadius: '50%',
      };
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.day}>
        <div className={classes.head}>
          <div>{weekInit[index]}</div>
          <div className={classes.num} style={styleContrl()}>
            {num}
          </div>
        </div>
        <div className={classes.body}>{children}</div>
      </div>
    </div>
  );
}
